<template>
  <div class="market-container">
    <p
      class="market-item"
      :class="{ 'market-item__active': market.slug === marketSelected }"
      v-for="(market, index) in markets"
      :key="index"
      @click="handleClickMarket(market)"
    >
      {{ getTranslatedText(market.name) }}
    </p>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import EventBus from "@/utils/EventBus";
export default {
  mixins: [languageMixins],
  props: {
    markets: {
      type: Array,
    },
    disableLiveStreamButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      marketSelected: "",
    };
  },
  watch: {
    markets: {
      handler(markets) {
        if (!markets || !markets.length) {
          this.marketSelected = "";
          return;
        }
        this.marketSelected = markets[0].slug;
      },
      deep: true,
    },
  },
  created() {
    this.handleInitMarketSelected(this.markets);
    this.scrollItemToCenter();
  },
  methods: {
    handleInitMarketSelected(markets) {
      this.marketSelected =
        this.$store.state.stateAction.marketSelected || markets[0]?.slug;
    },

    handleClickMarket(market) {
      const { query, params } = this.$route;
      const { gameSlug } = params;
      const path = `/coupons/${gameSlug}`;
      this.$router.push({ path, query });

      this.marketSelected = market.slug;
      this.$emit("handle-get-market", this.marketSelected);
      this.$store.commit("setMarketSelected", this.marketSelected);
      if (this.$store.state.isScreenMobile) {
        this.scrollItemToCenter();
      }
    },

    playLiveStream() {
      EventBus.emit("play-live-stream", true);
    },

    scrollItemToCenter() {
      setTimeout(() => {
        const item = document.querySelector(".market-item__active");
        if (item) {
          item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }, 100);
    },
  },
};
</script>

<style lang="scss">
@import "@/public/scss/components/coupons/market.scss";
</style>

